<template>
    <div>
        <div class="warp">
            <!-- 面包屑 -->
            <!-- <breadcrumb :back="false" :crubList="[{name:'审核管理'},{name:'股权融资发布审核'}]" :title="'股权融资发布审核'"/> -->
            <!-- 选项卡 -->
            <el-tabs v-model="tab" @tab-click="changeTab" class="super_tab">
              <el-tab-pane label="待审核" name="1" v-if="authorities.indexOf('sys:permission:background:equity:release:unAudit')!==-1"></el-tab-pane>
              <el-tab-pane label="审核记录" name="2" v-if="authorities.indexOf('sys:permission:background:equity:release:audit')!==-1"></el-tab-pane>
            </el-tabs>
            <!-- 查询条件 -->
            <div class="retrieve" ref="condition">
                <div class="left">
                    <div class="child" v-show="tab==='2'">
                        <span class="name">审核结果</span>
                        <el-select v-model="sendInfoOne.checkStatus" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="child">
                        <span class="name">提交日期</span>
                        <el-date-picker
                            size="small"
                            v-model="dateS"
                            format="yyyy-MM-dd"
                        	value-format="yyyy-MM-dd HH:mm:ss"
                        	type="datetimerange" 
                        	:default-time="['24:00:00','23:59:59']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <div class="child super_select">
                        <span class="name">检索</span>
                        <el-select v-model="getSelect" placeholder="请选择" size="small" clearable>
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input v-model="getValue" placeholder="请输入" size="small" clearable></el-input>
                    </div>
                    <el-button type="primary" size="small" @click="getData" class="retrievalBtn">查询</el-button>
                    <el-button size="small" @click="onReset" class="retrievalBtn">重置</el-button>
                </div>
            </div>
            <!-- 表格 -->
            <!-- 表格1 -->
            <el-table
                v-show="tab==='1'"
                :data="tableData"
                @sort-change="sortChange"
                ref="table"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="projectName"
                    show-overflow-tooltip
                    
                    width="300"
                    label="项目名称">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
				v-if="authorities.indexOf('sys:permission:background:equity:release:unAudit:button:view')!=-1||authorities.indexOf('sys:permission:background:equity:release:unAudit:button:audit')!=-1"
                    label="操作"
                    
                    width="200">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain
                        v-if="authorities.indexOf('sys:permission:background:equity:release:unAudit:button:view')!=-1" 
                        @click="check(scope.row)">查看</el-button>
                        <el-button size="small" type="primary" class="super" plain
                        v-if="authorities.indexOf('sys:permission:background:equity:release:unAudit:button:audit')!=-1" 
                        @click="audit(scope.row)">审核</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表格2 -->
            <el-table
                v-show="tab==='2'"
                :data="tableData"
                @sort-change="sortChange"
                ref="multipleTable"
                fit
                :height="bHeight"
                :header-cell-style="headerStyle"
                v-loading="loading"
                element-loading-text="请求中......"
                style="width: 100%">
                <el-table-column
                    prop="id"
                    show-overflow-tooltip
                    
                    label="申请ID">
                </el-table-column>
                <el-table-column
                    prop="createUserName"
                    show-overflow-tooltip
                    
                    label="账号">
                </el-table-column>
                <el-table-column
                    prop="createName"
                    show-overflow-tooltip
                    
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="projectName"
                    show-overflow-tooltip
                    
                    width="300"
                    label="项目名称">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="提交时间">
                </el-table-column>
                <el-table-column
                    prop="modifyUserName"
                    show-overflow-tooltip
                    
                    width="150"
                    label="审核账号">
                </el-table-column>
                <el-table-column
                    prop="updateTime"
                    show-overflow-tooltip
                    
                    sortable="custom"
                    width="150"
                    label="审核时间">
                </el-table-column>
                <el-table-column
                    prop="checkStatusValue"
                    show-overflow-tooltip
                    
                    label="审核结果">
                </el-table-column>
                <el-table-column
                    label="操作"
                    
					v-if="authorities.indexOf('sys:permission:background:equity:release:audit:button:view')!=-1"
                    width="100">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" class="super" plain  @click="check(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination" ref="pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 15, 20]"
                    :page-size="sendInfoOne.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalSize">
                </el-pagination>
            </div>
            <!-- 弹出成模块 -->
            <!-- 查看明细 -->
            <el-dialog
                title="申请信息"
                :visible.sync="dialogInfo"
                width="50%">
                <div class="basic">
                    <div  class="boxChild">
                        <div class="basisTitle">账号信息</div>
                        <div class="child" v-if="detailInfo.userVo">
                            <div class="name">账号：</div>
                            <div class="content">{{detailInfo.userVo.userName}}</div>
                        </div>
                        <div class="child" v-if="detailInfo.userVo">
                            <div class="name">账号类型：</div>
                            <div class="content">{{detailInfo.userVo.userTypeName}}</div>
                        </div> 
                        <div class="child" v-if="detailInfo.userVo">
                            <div class="name">姓名：</div>
                            <div class="content">{{detailInfo.userVo.realName}}</div>
                        </div>
                        <div class="child" v-if="detailInfo.userVo">
                            <div class="name">邮箱：</div>
                            <div class="content">{{detailInfo.userVo.email}}</div>
                        </div>
                        <div class="child" v-if="detailInfo.userVo">
                            <div class="name">联系地址：</div>
                            <div class="content">{{detailInfo.userVo.email}}</div>
                        </div>
                    </div>
                    <div class="boxChild">
                        <div class="basisTitle">股权融资项目信息</div>
                        <div class="smallTitle">基本信息</div>
                        <div class="child">
                            <div class="name">项目名称：</div>
                            <div class="content">{{detailInfo.projectName||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">简要描述：</div>
                            <div class="content">{{detailInfo.description||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">封面LOGO：</div>
                            <div class="content"><img class="logos" :src="detailInfo.logo"></div>
                        </div>
                        <div class="smallTitle">概况</div>
                        <div class="child">
                            <div class="name">行业：</div>
                            <div class="content">{{detailInfo.tradeValue||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">轮次：</div>
                            <div class="content">{{detailInfo.roundsValue||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">出让股权比例：</div>
                            <div class="content">{{detailInfo.equity||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">融资金额：</div>
                            <div class="content">{{detailInfo.financingAmount||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司名称：</div>
                            <div class="content">{{detailInfo.companyName||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">项目网址：</div>
                            <div class="content">{{detailInfo.projectUrl||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">公司地址：</div>
                            <div class="content">{{detailInfo.companyAddr||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">成立时间：</div>
                            <div class="content">{{detailInfo.foundTime||'--'}}</div>
                        </div>
                        <div class="child">
                            <div class="name">项目概述：</div>
                            <div class="content super_p" v-html="detailInfo.projectOutline" v-if="detailInfo.projectOutline"></div>
                            <div class="content" v-else>--</div>
                        </div>
                        <div class="smallTitle">团队</div>
                        <div class="tableChild">
                            <el-table
                                :data="detailInfo.teamList"
                                border
                                style="width: 100%">
                                <el-table-column
                                    prop="name"
                                    label="姓名"
                                    
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    prop="position"
                                    label="职位"
                                    
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    prop="introduction"
                                    
                                    label="介绍">
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="smallTitle">融资情况</div>
                        <div class="tableChild">
                            <el-table
                                :data="detailInfo.finList"
                                border
                                style="width: 100%">
                                <el-table-column
                                    prop="equityTime"
                                    label="时间"
                                    
                                    width="150">
                                </el-table-column>
                                <el-table-column
                                    prop="roundsValue"
                                    label="轮次"
                                    
                                    width="100">
                                </el-table-column>
                                <el-table-column
                                    prop="financingAmount"
                                    
                                    width="100"
                                    label="金额">
                                </el-table-column>
                                <el-table-column
                                    prop="mechanism"
                                    
                                    label="机构">
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="smallTitle">财务状况</div>
                        <div class="tableChild">
                            <el-table
                                :data="detailInfo.financeList"
                                border
                                style="width: 100%">
                                <el-table-column
                                    prop="year"
                                    label="年份"
                                    >
                                </el-table-column>
                                <el-table-column
                                    prop="totalAssets"
                                    label="总资产（元）"
                                    >
                                </el-table-column>
                                <el-table-column
                                    prop="openIncome"
                                    
                                    label="营业收入（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="grossProfit"
                                    
                                    label="毛利润（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="grossProfitRate"
                                    
                                    label="毛利润率">
                                </el-table-column>
                                <el-table-column
                                    prop="netProfit"
                                    
                                    label="净利润（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="netProfitRate"
                                    
                                    label="净利润率">
                                </el-table-column>
                                <el-table-column
                                    prop="totalLiability"
                                    
                                    label="总负债（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="totalLiabilityRate"
                                    
                                    label="负债率">
                                </el-table-column>
                                <el-table-column
                                    prop="ownerEquity"
                                    
                                    label="所有者权益（元）">
                                </el-table-column>
                                <el-table-column
                                    prop="numOrEmploy"
                                    
                                    label="从业人数">
                                </el-table-column>
                            </el-table>
                        </div>
                        <div class="smallTitle">BP</div>
                        <div class="attachment">
                            <ul class="content">
                                <li><span>{{detailInfo.bpName}}</span><i class="el-icon-download" @click="downLoad(detailInfo.frontPath+detailInfo.bpPath)"></i></li>
                            </ul>
                        </div>
                        <div class="smallTitle">联系方式</div>
                        <div class="child">
                            <div class="name">项目联系人：</div>
                            <div class="content">{{detailInfo.projectContact}}</div>
                        </div>
                        <div class="child">
                            <div class="name">联系手机号：</div>
                            <div class="content">{{detailInfo.contactPhone}}</div>
                        </div>
                        <div class="smallTitle">信息采集协议</div>
                        <div class="child">
                            <div class="name">是否同意《信息采集协议》：</div>
                            <div class="content">是</div>
                        </div>
                        <!-- <div class="child">
                            <div class="name">发布账号：</div>
                            <div class="content">admin001</div>
                        </div>
                        <div class="child">
                            <div class="name">发布时间：</div>
                            <div class="content">admin001</div>
                        </div>
                        <div class="child">
                            <div class="name">更新账号：</div>
                            <div class="content">admin001</div>
                        </div>
                        <div class="child">
                            <div class="name">更新时间：</div>
                            <div class="content">admin001</div>
                        </div> -->
                    </div>
                    <div class="boxChild" v-if="tab==='2'">
                        <div class="basisTitle">认证信息</div>
                        <div class="child">
                            <div class="name">审核结果：</div>
                            <div class="content">{{detailInfo.checkStatusValue}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detailInfo.createUserName}}</div>
                        </div>
                        <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detailInfo.updateTime}}</div>
                        </div>
                        <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detailInfo.auditInstructions}}</div>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 审核 -->
            <el-dialog
                title="审核"
                :visible.sync="dialogAudit"
                width="30%">
                <div class="forms">
                    <div class="child">
                        <div class="name"><span>*</span>审核结果：</div>
                        <el-radio-group v-model="sendInfoTwo.result">
                            <el-radio :label="item.value" v-for="(item,index) in statusList" :key="index">{{item.name}}</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="error" v-if="errors['sendInfoTwo.result']">错误提示：{{errors['sendInfoTwo.result']}}</div>
                    <div class="childTextarea">
                        <div class="name">说明：</div>
                        <div class="content"><el-input type="textarea" v-model="sendInfoTwo.checkRemark" show-word-limit maxlength="200"></el-input></div>
                    </div>
                    <div class="child">
                        <div class="name"></div>
                        <div class="content">
                          <div class="doubleBtn">
                            <el-button size="small"  type="primary" @click="submit">确认</el-button>
                              <el-button size="small"  @click="cancel">取消</el-button>
                          </div>
                        </div>
                    </div>
                    
                </div>
        </el-dialog>
        </div>
    </div>
</template>

<script>
import timeMixins from "@/mixins/timeFormat";
// import breadcrumb from '../../components/breadcrumb';
export default {
    mixins:[timeMixins],
    components:{
        // breadcrumb
    },
    data(){
        return{
          loading:false,
          bHeight: void 0,
			authorities:JSON.parse(window.localStorage.getItem('authorities')),
            statusList:[],//审核结果
            options: [{
                value: '2',
                label: '账号'
                }, {
                value: '3',
                label: '姓名'
            }, {
                value: '4',
                label: '项目名称'
            }],//检索下拉
            getSelect:'',//检索下拉的值
            getValue:'',//检索输入框的值
            dateS:[],//日期
            sendInfoOne:{
                currentPage:1,//当前页
                pageSize:10,//页条数
                checkStatus:'',//审核状态
                endDate:'',//结束时间
                startDate:'',//开始时间
                id:"",//申请id
                userName:'',//账号
                name:'',//姓名
                projectName:'',//项目名称
                property:null,//排序字段
                direction:null,//排序方式
            },//检索提交数据
            tab:'1',//选项卡
            tableData:[],//表格数据
            currentPage:1,//当前页
            dialogInfo:false,//查看明细弹出层
            dialogAudit:false,//审核弹出层
            sendInfoTwo:{
                id:'',
                approvalModule:'equityFinancing',
                result:null,//审核结果
                checkRemark:'',//说明
            },//审核提交数据
            totalSize:null,
            scopeListArray:[],
            scopeList:[],
            detailInfo:{
                projectName:"",//项目名称：
                description:"",//简要描述：
                logo:"",//封面LOGO：
                tradeValue:"",//行业：
                roundsValue:"",//轮次：
                equity:"",//出让股权比例：
                financingAmount:"",//融资金额：
                companyName:"",//公司名称：
                projectUrl:"",//项目网址：
                companyAddr:"",//公司地址：
                foundTime:"",//成立时间：
                projectOutline:"",//成立时间：
                teamList:[],//团队
                finList:[],//融资情况
                financeList:[],//财务状况
                projectContact:"",//项目联系人：
                contactPhone:"",//联系手机号：
                checkStatusValue:"",//审核结果：
                updateTime:"",//审核时间：
                auditInstructions:"",//说明：
                createUserName:"",//审核账号：
                bpName:'',//文件名称
                userVo:{
                    userName:"",//添加人账号
                    userTypeName:"",//账号类型：
                    realName:"",//姓名：
                    email:"",//邮箱：
                    contactAddress:"",//联系地址：
                    realName:"",//姓名：
                }
            }
        }
    },
    computed: {
        errors() {
            return this.$vuerify.$errors // 错误信息会在 $vuerify.$errors 内体现
        },
    },
    vuerify: {
        'sendInfoTwo.result':{
            test:function(){
                if(this.sendInfoTwo.result){
                    return true;
                }else{
                    return false;
                }
            },
            message:'选择审核结果'
        },
    },
    methods:{
      doLayout() {
            this.$nextTick(() => {
              if (this.$refs.multipleTable && this.$refs.multipleTable.doLayout) {
                this.$refs.multipleTable.doLayout()
              }
              if (this.$refs.table && this.$refs.table.doLayout) {
                this.$refs.table.doLayout()
              }
            })
          },
          // 表头样式回调
          headerStyle() {
            return 'backgroundColor:#F7F7F7;fontSize:14px;color:#595959;fontWeight:500;padding:0;line-height:40px'
          },
		downLoad(url){
			window.open(url)
		},
      onReset(){
        this.getSelect='';//检索下拉的值
            this.getValue='';//检索输入框的值
            this.dateS=[];//日期
            this.sendInfoOne.currentPage=1;//当前页
            this.sendInfoOne.pageSize=20;//页条数
            this.sendInfoOne.checkStatus='';//审核状态
            this.sendInfoOne.endDate='';//结束时间
            this.sendInfoOne.startDate='';//开始时间
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.projectName='';//债权产品名称
            this.totalSize=null;//总页码
            this.getData();
      },
        // 切换选项啦
        changeTab:function(tab){
            this.tab=tab.name;
            this.onReset()
        },
        //表格排序事件
        sortChange:function({ column, prop, order }){
            if(order=='ascending'){
                order='asc';
            }else{
                order='desc';
            }
            this.sendInfoOne.property=prop;
            this.sendInfoOne.direction=order;
            this.getData();
        },
        //分页功能模块
        //切换每页显示条数
        handleSizeChange(val) {
            this.sendInfoOne.pageSize=val;
            this.getData();
        },
        //切换页码
        handleCurrentChange(val) {
            this.sendInfoOne.currentPage=val;
            this.getData();
        },
        //查看明细
        check:function(row){
            this.$router.push({path: `/auditsManagement/releaseEquity/detail/${this.tab}`, query: {id: row.id, index: '/auditsManagement/releaseEquity'},param:{type:this.tab}})
            // this.dialogInfo=true;
            // this.$axiosc.get('backstage/equity/financing/reviewLog/details/'+row.id).then(res=>{
            //     if(res.code ==200){
            //         this.detailInfo = res.data
            //         this.detailInfo.logo = this.detailInfo.frontPath+this.detailInfo.logo
            //     }else{
            //         this.$alert(r.msg)
            //     }
            // })
        },
        //打开审核
        audit:function(row){
            this.sendInfoTwo.id = row.id
            this.sendInfoTwo.result = null
            this.sendInfoTwo.checkRemark = ''
            this.dialogAudit=true;
        },
        //取消按钮
        cancel:function(){
            this.$vuerify.clear();
            this.dialogAudit=false
        },
        //保存按钮
        submit:function(){
            this.$vuerify.clear();
            if(this.$vuerify.check()){
                this.$axiosc.put('backstage/common/approval',this.$qs.stringify(this.sendInfoTwo)).then(res=>{
                    if(res.code == 200){
                        this.getData()
                        this.$message({
                            type: 'success',
                            message: '审核成功！',
                        });
                        this.dialogAudit = false
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg,
                        });
                    }
                })
            }
        },
        //获取字典
        getDic:function(){
          // this.$axiosz.get('backstage/sysDict/CHECK_STATUS').then((r)=>{ //审核结果
            this.$axiosz.get('backstage/sysDict/auditOption').then((r)=>{ //审核结果
                if(r.code==200){
                    // r.data.shift()
                    this.statusList=r.data;
                }
            })
        },
        getData(){
            this.loading = true
            this.tableData=[];
            if(this.dateS&&this.dateS.length>0){
                 this.sendInfoOne.startDate=this.dateS[0];
                 this.sendInfoOne.endDate=this.dateS[1];
             }else{
                 this.sendInfoOne.startDate=null;
                 this.sendInfoOne.endDate=null;
             }
            this.sendInfoOne.id="";//申请id
            this.sendInfoOne.userName='';//账号
            this.sendInfoOne.name='';//姓名
            this.sendInfoOne.projectName='';//债权产品名称
            if(this.getSelect=='1'){ //申请id
                this.sendInfoOne.id=this.getValue;
            }else if(this.getSelect=='2'){ //账号
                this.sendInfoOne.userName=this.getValue;
            }else if(this.getSelect=='3'){ //姓名
                this.sendInfoOne.name=this.getValue;
            }else if(this.getSelect=='4'){ //项目名称
                this.sendInfoOne.projectName=this.getValue;
            }
            let url='';
            this.scopeList = []
            if(this.tab==='1'){
                url='backstage/equity/financing/pending/review/list';
            }else{
                url='backstage/equity/financing/audited/list';
            }
            this.$axiosc.get(url,{params:this.sendInfoOne}).then((r)=>{
                this.loading = false
                if(r.code==200){
                    this.tableData=r.data.content;
                    this.totalSize=r.data.totalElements;
                }else{
                    this.$alert(r.msg)
                }
            }).catch(e=>{
              this.loading = false
            })
        }
    },
    mounted(){
      const that = this
        that.getDic();
		  // 待审核
      if(that.authorities.indexOf('sys:permission:background:equity:release:unAudit')==-1){
        that.tab='2'
      }
      // 待审核 和审核记录存在一个
      if(that.authorities.indexOf('sys:permission:background:equity:release:unAudit')!=-1||that.authorities.indexOf('sys:permission:background:equity:release:audit')!=-1){
        that.getData()
      }
      let bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90
          that.bHeight = document.body.clientHeight - 64  - bh 
          that.doLayout()
          window.onresize = () => {
            return (() => {
              that.$nextTick(() => {
                  bh = 44 + (that.$refs.condition?that.$refs.condition.offsetHeight:0) +  (that.$refs.pagination?that.$refs.pagination.offsetHeight:0) + 90
                  that.bHeight = document.body.clientHeight - 64  - bh 
                  that.doLayout()
              })
            })()
          }
    }
}
</script>

<style lang="scss" scoped>
</style>